import { DataTestId, TextKey } from '@mews-commander/enums';
import { LocalizedMinorHighlight, LocalizedSmallParagraph } from '@mews-commander/ui';
import { openInBrowserTab } from '@mews-commander/utils';
import { MewsImage } from '@mews/business-components';
import { LocalizedText } from '@mews/framework';
import { Button } from '@optimus-web/core';
import { Widget } from '../Widget';
import mewsCommunityPhoto from './assets/mews_community.png';
import { mewsCommunityUrl } from './constants';

const imageHeight = '196px';

export const MewsCommunityWidget = () => {
    const handleClick = () => openInBrowserTab(mewsCommunityUrl);

    return (
        <Widget titleTextKey={TextKey.Community}>
            <MewsImage
                src={mewsCommunityPhoto}
                height={imageHeight}
                objectFit="contain"
                objectPosition="left top"
                shouldShowLoader
            />
            <LocalizedMinorHighlight textKey={TextKey.DashboardWidgetMewsCommunityHeaderText} />
            <LocalizedSmallParagraph textKey={TextKey.DashboardWidgetMewsCommunityText} />
            <div>
                <Button
                    onClick={handleClick}
                    data-test-id={DataTestId.DashboardWidgetMewsCommunityButton}
                    type="submit"
                >
                    <LocalizedText textKey={TextKey.DiscoverMore} />
                </Button>
            </div>
        </Widget>
    );
};
